"use client";

import { useState, useCallback } from "react";
import { ToastProvider } from "@/components/shared/Toast";
import Hero from "@/components/public/Hero";
import InfoBar from "@/components/public/InfoBar";
import Gallery from "@/components/public/Gallery";
import ArtworkQuickView from "@/components/public/ArtworkQuickView";

import { useScrollReveal } from "@/lib/useScrollReveal";

export default function HomeClient({
  artworks,
  heroItems,
  heroSlides,
  brandSettings,
  heroPillItems = [],
  blogSlot,
  footerSlot,
}) {
  const [quickViewArtwork, setQuickViewArtwork] = useState(null);

  const handleQuickView = useCallback((artwork) => {
    setQuickViewArtwork(artwork);
  }, []);

  useScrollReveal();

  return (
    <ToastProvider>
      <main>
        <Hero
          initialHeroItems={heroItems}
          initialSlides={heroSlides}
          initialBrand={brandSettings}
        />
        <InfoBar initialPills={heroPillItems} />
        <Gallery artworks={artworks} onQuickView={handleQuickView} />
        {blogSlot}
      </main>
      {footerSlot}
      <ArtworkQuickView
        artwork={quickViewArtwork}
        onClose={() => setQuickViewArtwork(null)}
      />
    </ToastProvider>
  );
}
